import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, User, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

import { API_URL } from '../../config/api';
const API = `${API_URL}/api`;

// Composant Logo SVG sans fond
function LogoBatiAssist({ className = "h-12" }) {
  return (
    <div className="flex items-center gap-2">
      <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4L4 16V36H16V24H24V36H36V16L20 4Z" fill="#F97316"/>
        <path d="M20 4L4 16H12L20 10L28 16H36L20 4Z" fill="#EA580C"/>
      </svg>
      <span className="font-bold text-xl">
        <span className="text-[#1E40AF]">Bati</span>
        <span className="text-[#F97316]">Assist</span>
      </span>
    </div>
  );
}

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Connexion reussie');
      navigate('/admin');
    } catch (error) {
      toast.error('Identifiants invalides');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen min-h-[100dvh] bg-gradient-to-br from-ba-primary to-ba-primary/80 flex items-center justify-center p-4 sm:p-6" 
      data-testid="admin-login-page"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-2xl p-5 sm:p-6 md:p-8 w-full max-w-md"
      >
        <div className="text-center mb-5 sm:mb-6">
          <div className="flex justify-center mb-2 sm:mb-3">
            <LogoBatiAssist className="h-12 sm:h-14" />
          </div>
          <h1 className="text-lg sm:text-xl font-bold text-rm-text">Administration</h1>
          <p className="text-sm text-rm-text-secondary">Connecte-toi pour acceder au dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          <div>
            <label className="block text-sm font-medium text-rm-text mb-2">
              Identifiant
            </label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="pl-12 py-3 sm:py-3.5 rounded-xl text-base touch-manipulation"
                autoComplete="username"
                data-testid="admin-username"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-rm-text mb-2">
              Mot de passe
            </label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-12 py-3 sm:py-3.5 rounded-xl text-base touch-manipulation"
                autoComplete="current-password"
                data-testid="admin-password"
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={isLoading}
            className="w-full bg-ba-primary hover:bg-ba-primary/90 text-white font-semibold rounded-xl py-3.5 sm:py-4 md:py-5 touch-manipulation active:scale-98"
            data-testid="admin-login-submit"
          >
            {isLoading ? 'Connexion...' : 'Se connecter'}
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </form>

        <p className="text-center text-xs sm:text-sm text-rm-text-secondary mt-5 sm:mt-6">
          Identifiants : admin / recrutermalin2024
        </p>
      </motion.div>
    </div>
  );
}
